import { gql } from '@apollo/client';

export const VALIDATE_PROMO_CODE = gql`
  query Flex_ValidatePromoCode($promoCode: String) {
    validation {
      promoCode(promoCode: $promoCode) {
        isValid
      }
    }
  }
`;
